export const ECOMMERCE = 'ECOMMERCE'
export const LEAD_GEN = 'LEAD GEN'
export const SOCIAL = 'SOCIAL'
export const INSTAGRAM_SHOPPABLE = 'INSTAGRAM SHOPPABLE'
export const MOBILE_APP_LANDING = 'MOBILE APP LANDING'



// WEBPACK FOOTER //
// ./src/constants/templateCategory.js